import React from 'react';
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import StorefrontLoginPanel from '../components/StorefrontLoginPanel';
import '../styles/StorefrontLoginPage.css';

const StorefrontLoginPage = () => {
  const { companyUrl } = useParams();
  const location = useLocation();
  const { companyData } = useOutletContext();
  const returnPath = location.state?.from || `/book/${companyUrl}`;

  return (
    <div className="storefront-login-page">
      <div className="container">
        <div className="storefront-login-page__content">
          <StorefrontLoginPanel
            companyData={companyData}
            companyUrl={companyUrl}
            returnPath={returnPath}
          />
        </div>
      </div>
    </div>
  );
};

export default StorefrontLoginPage;
